export default "__VITE_ASSET__BDadiG8O__"